module.exports = __webpack_public_path__ + "static/media/opkomst-blokken.d439ee41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Seats/assets/opkomst-blokken.svg
// module id = 478
// module chunks = 0